const processInternalUrl = url => {
    const hostname = document.location.hostname;
    const port = document.location.port;

    if (url && url.indexOf(hostname) > -1) {
        url = url.split(hostname);
        if (port) {
            url = url[1].split(port);
        }
        url = url[1] || url[0];
    }

    return url;
};

export default processInternalUrl;
